import React from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../app/store'
import { t } from '../../i18n'
import Footer from '../../components/Footer';
import Alert from '../../components/AlertMessage'
import ForgetPasswordForm from '../../components/ForgetPasswordForm';
import { LogoWrapper } from './styles';
import {
  CommonContainer,
  CenteredContainer,
  DailaiLogo
} from '../../globalStyles'


function ForgotPassword() {
    const { isRequestSuccess, errorRequestMessage} = useSelector((state: RootState) => state.resetPasswordRequest)
    const { language } = useSelector((state: RootState) => state.language)

    console.log("errorRequestMessage: ", errorRequestMessage)
    return (
      <>
        <CommonContainer>
          <CenteredContainer style={{flexDirection: 'column'}}>
          {errorRequestMessage ?
            <Alert
              text={errorRequestMessage}
              bgColor="#f8d7da"
              txtColor="#721c24"
              /> : null
          }
            <LogoWrapper>
              <DailaiLogo src="https://res.cloudinary.com/dba8ifej6/image/upload/v1644372534/dailai_auth_logo_ikt3gm.png" />
            </LogoWrapper>
            {isRequestSuccess ?
              <p>{t('An email has been sent to reset your password.', language)}</p>
              :
              <ForgetPasswordForm />
            }
          </CenteredContainer>
        </CommonContainer>
        <Footer />
      </>
    )
}

export default ForgotPassword
